
define('ldsh!modules/start/products/base/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="row">\n    <div class="col-md-12 col-lg-12">\n        <div class="panel panel-default newproduct product-shadow ' +
__e( productType ) +
' ' +
__e( active ? 'active' : '' ) +
'">\n            <div class="panel-body">\n                <div class="row">\n                    <!-- product logo/button -->\n                    <div class="product-logobutton"></div>\n                        ';
 if (productsReport.isRequest) { ;
__p += '\n                            <div class="text-center">\n                                <i class="ri-loader-4-fill fa-spin product-spinner"></i>\n                            </div>\n                        ';
 } else { ;
__p += '\n                            <!-- product data -->\n                            <div class="product-activity"></div>\n                            <!-- product status -->\n                            <div class="product-status"></div>\n                            <!-- product info -->\n                            <div class="product-info"></div>\n                        ';
 } ;
__p += '\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';

}
return __p
};});

